import React from 'react'
import StatusIncoming from './Status'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'

function IndexIncomeSettings() {
    return(
        <>
        <TextMediumSM content="Finance" />
        <TextMediumSM content="Incoming" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusIncoming/>
         </div>
         
         </div>
         </>
    )
}

export default IndexIncomeSettings
